import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/modules/current-user/permissions/permissions';

export const risksRoutes = [
  {
    path: 'risks/:riskNumber?',
    name: 'risks',
    component: () => import('./RisksPage.vue'),
    props: true,
    meta: {
      permissions: [Permission.ClientsRisksView],
    },
  },
] satisfies RouteRecordRaw[];
